/**
 * Format date object into a date only string.
 * @param {Date} date - Date object that will be formatted.
 * @returns {string} - A string in the locale format
 *
 * @example
 * dateToDateString(new Date(2025, 1, 12));
 * // Returns a format like '12/01/2025' for en-US locale.
 */
export default function dateToDateString(date) {
  return date.toLocaleString(navigator.language, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
}
